<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('warehouse.one-category')}`
          : `${$t('common.edit')} ${$t('warehouse.one-category')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
           
          </b-col>
          <b-col md="">
            <CategoryModal
              :isPharmacy="$route.name.includes('pharmacy') ? true : false"
              @category="assignCategoryInForm"
            />
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('warehouse.category')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.category") }}</h2>
            <br />
          </b-col>

          <b-col md="6" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="categoryName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="2"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getCategoriesList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.category") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-category')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("warehouse.one-category") }}
          </b-button>
        </div>

        <b-table
          fixed
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(has_sub-category)="data">
            <div class="d-flex">
              <b-badge
                class="cursor-pointer"
                variant="success"
                v-if="data.item.childs.length !== 0"
                @click="
                  $router.push({
                    name: `${
                      $route.name.includes('pharmacy')
                        ? 'pharmacy-subcategory'
                        : 'subcategory'
                    }`,
                    params: { id: data.item.id, name: data.item.name },
                  })
                "
              >
                {{ $t("warehouse.see-sub-category") }}</b-badge
              >
              <b-badge v-else variant="danger">{{
                $t("warehouse.no-sub")
              }}</b-badge>
            </div>
          </template>
          <template #cell(has_items)="data">
            <div class="d-flex">
              <b-badge
                class="cursor-pointer"
                variant="success"
                v-if="data.item.items.length !== 0"
                @click="
                  $router.push({
                    name: `${
                      $route.name.includes('pharmacy')
                        ? 'pharmacy-item'
                        : 'item'
                    }`,
                    params: { id: data.item.id, name: data.item.name },
                  })
                "
              >
                {{ $t("warehouse.see-items") }}</b-badge
              >
              <b-badge v-else variant="danger">
                {{ $t("warehouse.no-items") }}</b-badge
              >
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <!-- Dropdown -->
              <ActionsButtons
                deletePerm="delete-category"
                editPerm="update-category"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />

              <!-- <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click="show(data.item)"
                  v-if="
                    $store.state.app.permissions.includes('update-category')
                  "
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    $store.state.app.permissions.includes('delete-category')
                  "
                  @click="deleteModel(data.item)"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown> -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-category") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getCategoriesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BBadge,
  BFormRadio,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    CategoryModal,
    BBadge,
    ActionsButtons,
    DeleteModal,
    BFormRadio,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        parent_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        parent_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "has_sub-category",
          label: this.$t("warehouse.has-sub"),
          sortable: true,
        },
        {
          key: "has_items",
          label: this.$t("warehouse.has-items"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getCategoriesList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          parent_id: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.parent_id = item.parent_id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    assignCategoryInForm(v) {
      this.EditForm.parent_id = v.id;
    },
    async getCategoriesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/category?filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.categoryName) {
        url += `&filter[name]=${this.categoryName}`;
      }
      if (this.parentIdFilter) {
        url += `&filter[parent_id]=${this.parentIdFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/category/${this.deleteForm.id}`)
        .then((response) => {
          this.getCategoriesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      this.errorForm.name = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.type = this.$route.name.includes("pharmacy")
        ? "pharmacy"
        : "hospital";
      if (!this.EditForm.name) {
        this.errorForm.name = "The name field is required.";
        this.loading = false;
        return false;
      }
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/category`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getCategoriesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/category/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getCategoriesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
